import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '../../services/brand/brandServiceInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: "h-10 w-auto",
    src: _unref(brandService).getLogo()
  }, null, 8, _hoisted_1))
}
}

})